import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Music2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useSettings } from '../context/SettingsContext';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_travel-booking-hub-90/artifacts/txbpb6pw_20260506_060747_0000.png';

const Footer = () => {
  const { t } = useLanguage();
  const { settings } = useSettings();
  const s = settings || {};
  return (
    <footer className="bg-black border-t border-white/5 pt-16 pb-8 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <img src={LOGO_URL} alt="TTS" className="h-28 w-auto object-contain mb-4" />
            <p className="text-white/60 text-sm leading-relaxed">{t.footer.about}</p>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 text-sm tracking-wider uppercase">{t.footer.services}</h4>
            <ul className="space-y-2 text-sm">
              {t.services.items.slice(0,5).map((sv, i) => (
                <li key={i}><a href="#services" className="text-white/60 hover:text-[#ff6b1a] transition-colors">{sv.title}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 text-sm tracking-wider uppercase">{t.footer.contact}</h4>
            <ul className="space-y-3 text-sm text-white/60">
              {s.phone && <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#ff6b1a]" /> {s.phone}</li>}
              {s.email && <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#ff6b1a]" /> {s.email}</li>}
              {s.address && <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-[#ff6b1a] mt-0.5" /> {s.address}</li>}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 text-sm tracking-wider uppercase">{t.footer.followUs}</h4>
            <div className="flex gap-3 flex-wrap">
              {s.facebook_url && (
                <a href={s.facebook_url} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#1877F2] flex items-center justify-center transition-colors">
                  <Facebook className="w-5 h-5" />
                </a>
              )}
              {s.instagram_url && (
                <a href={s.instagram_url} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#E4405F] flex items-center justify-center transition-colors">
                  <Instagram className="w-5 h-5" />
                </a>
              )}
              {s.tiktok_url && (
                <a href={s.tiktok_url} target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="w-10 h-10 rounded-full bg-white/5 hover:bg-black flex items-center justify-center transition-colors border border-white/10">
                  <Music2 className="w-5 h-5" />
                </a>
              )}
              {s.whatsapp_number && (
                <a href={`https://wa.me/${s.whatsapp_number}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#25D366] flex items-center justify-center transition-colors">
                  <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor"><path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488 11.824 11.824 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24z"/></svg>
                </a>
              )}
            </div>
            <Link to="/admin/login" className="text-white/30 hover:text-[#ff6b1a] text-xs mt-6 inline-block">Admin Panel</Link>
          </div>
        </div>
        <div className="section-divider my-8" />
        <p className="text-center text-white/40 text-xs">© {new Date().getFullYear()} {s.company_name || 'TTS'}. {t.footer.rights}.</p>
      </div>
    </footer>
  );
};

export default Footer;
